module.exports = __webpack_public_path__ + "media/images/icons/two-users-9b56147bb179344fa9ef17a7d67528ac.svg";